import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å°ç»
 */
@JsonObject
export class Group {
  /**
   * å®ä½id
   */
  @JsonProperty('id', Number, true)
  id: number = undefined;

  /**
   * åå»ºæ¶é´, æ¶é´æ³
   */
  @JsonProperty('createTime', Number, true)
  createTime: number = undefined;

  /**
   * æåä¿®æ¹æ¶é´, æ¶é´æ³
   */
  @JsonProperty('lastModified', Number, true)
  lastModified: number = undefined;

  /**
   * å°ç»çæè¿°
   */
  @JsonProperty('desc', Object)
  desc: string = undefined;

  /**
   * å°ç»çåç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;

  /**
   * å°ç»æå±å»é¢Id
   */
  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  /**
   * æåºæ è¯
   */
  @JsonProperty('idx', Number)
  idx: number = undefined;
}
